import React from 'react';
// import { zoneToCubePositions } from "../../../DeployToken/Sections/SelectionData";
import DeployedTokenCube from './DeployedTokenCube';
import { getDefaultZoneName, getMyTokenFill, getZoneCatByZoneArea } from './court.data';
import { useSelector } from 'react-redux';

const BASKETBALL_X_BASELINE = 28.967;
const BASKETBALL_X_STEP = 27.957;
const BASKETBALL_Y_BASELINE = 2.0;
const BASKETBALL_Y_STEP = 29.954;

const resolveCoordinate = (val, baseline, step, maxIndex) => {
  const num = Number(val);
  if (isNaN(num)) return 0;
  
  // If it's an integer and within the valid index range, treat it as a grid index.
  // Basketball indices are 0-46 for X and 0-24 for Y.
  if (Number.isInteger(num) && num <= maxIndex) {
    return (num * step) + baseline;
  }
  return num;
};

const DeployedTokens = ({ purchasedTokens, disableTokenHover }) => {

  const { currentSeason } = useSelector((state) => state.seasons);

  return (
    <>
      {purchasedTokens?.map((token, key) => {
        const x = resolveCoordinate(
          token?.positionWithinCourt?.xAxis || token?.xAxis,
          BASKETBALL_X_BASELINE,
          BASKETBALL_X_STEP,
          60 // X threshold for indices vs pixels
        );
        const y = resolveCoordinate(
          token?.positionWithinCourt?.yAxis || token?.yAxis,
          BASKETBALL_Y_BASELINE,
          BASKETBALL_Y_STEP,
          30 // Y threshold for indices vs pixels
        );

        return (
          <DeployedTokenCube
            key={key}
            onClick={token?.onClick ? token?.onClick : () => {}}
            position={{ x, y }}
            // totalCount={token?.tokenCount}
            fill={getMyTokenFill(parseInt(getZoneCatByZoneArea(getDefaultZoneName(currentSeason?.zoneCategories,token?.zoneName))))}
            highlighted={token?.highlighted}
            disableTokenHover={disableTokenHover}
          />
        )
      })}
    </>
  );
};

export default DeployedTokens;
